import React from 'react';
import LeftPanel from '../questionnaire/LeftPanel';
import { NavLink } from 'react-router-dom';

function Container({ title, children, leftPanelComponent, fullWidthComponent }: { title: string, children: React.ReactNode, leftPanelComponent: React.ReactNode, fullWidthComponent?: React.ReactNode }) {
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item">
              <NavLink exact className="nav-link" to="/">Home <span className="sr-only">(current)</span></NavLink>
            </li>
            <li className="nav-item">
              <NavLink exact className="nav-link" to="/clients/choose">Clients</NavLink>
            </li>
          </ul>
        </div>
      </nav>
      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 text-center mb-5">
              <h2 className="heading-section">{title}</h2>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="wrapper">
                <div className="row no-gutters">
                  <div className="col-lg-8 col-md-7 order-md-last d-flex align-items-stretch">
                    {children}
                  </div>
                  <LeftPanel>{leftPanelComponent}</LeftPanel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {fullWidthComponent}
    </>
  );
}

export default Container;
